import { connect } from 'react-redux';
import Component from './component';

const mapStateToProps = (state) => ({
  saltusowners: state.saltusowners.get('data'),
  teammemberinfo: state.teammemberinfo.get('data'),
});
const mapDispatchToProps = () => ({});
export default connect(mapStateToProps, mapDispatchToProps)(Component);
